<div class="d-flex justify-content-center align-items-center h-100">
  <div class="login-container">
    <div class="d-flex justify-content-end mb-2">
      <app-language-switcher></app-language-switcher>
    </div>
    <form #loginForm="ngForm">
      <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" style="width: 100%;" />

      <div class="form-group mt-4">
        <label for="Password">{{ 'forgotPassword.newPassword' | transloco }}</label>
        <input type="password" id="Password" [(ngModel)]="formData.NewPassword" [placeholder]="'forgotPassword.newPasswordPlaceholder' | transloco" name="NewPassword" class="form-control"/>
      </div>
      <div class="form-group mt-2">
        <label for="Confirmpassword">{{ 'forgotPassword.confirmPassword' | transloco }}</label>
        <input type="password" id="Confirmpassword" [(ngModel)]="formData.ConfirmPassword" [placeholder]="'forgotPassword.confirmPasswordPlaceholder' | transloco" name="ConfirmPassword" class="form-control"/>
        @if (isPasswordMismatch()) {
          <div class="text-danger">{{ 'forgotPassword.passwordMismatch' | transloco }}</div>
        }
      </div>
      <!-- Submit button section -->
      <div class="form-group text-center mt-2">
        <div class="card flex justify-content-center">
          <button pButton type="button" class="p-button-default p-button-outlined" [label]="'forgotPassword.resetPassword' | transloco" [disabled]="!formData.NewPassword || !formData.ConfirmPassword" (click)="generateNewPassword()"></button>
        </div>
      </div>
      <!-- Login link section -->
      <div class="form-group text-center mt-2">
        <a [routerLink]="['/']">{{ 'forgotPassword.backToLogin' | transloco }}</a>
      </div>
    </form>
  </div>
</div>
